(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fleet-installation-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fleet-installation-directory')) {
customElements.define('fleet-installation-directory', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
this.input = this.querySelector('input[type="search"]');
this.cards = Array.from(this.querySelectorAll('[data-guide]'));
this.filters = Array.from(this.querySelectorAll('button[data-category]'));
this.category = 'all';
const params = new URLSearchParams(window.location.search);
const selected = params.get('application');
if (this.filters.some(button => button.dataset.category === selected)) this.category = selected;
this.input.value = params.get('guide_q') || '';
this.querySelector('[data-controls]').hidden = false;
this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.update(); });
this.input.addEventListener('input', () => this.update());
this.filters.forEach(button => button.addEventListener('click', () => { this.category = button.dataset.category; this.update(); }));
const reset = () => { this.input.value = ''; this.category = 'all'; this.update(); this.input.focus(); };
this.querySelector('[data-clear]').addEventListener('click', reset);
this.querySelector('[data-reset]').addEventListener('click', reset);
this.update(false);
}
normalize(value) { return value.toLowerCase().replace(/e[\s-]*z[\s-]*go/g, 'ezgo').replace(/[^a-z0-9]+/g, ' ').trim(); }
update(save = true) {
const words = this.normalize(this.input.value).split(' ').filter(Boolean);
let count = 0;
this.cards.forEach(card => {
const text = this.normalize(card.dataset.search + ' ' + card.textContent);
const matches = (this.category === 'all' || card.dataset.category === this.category) && words.every(word => text.includes(word));
card.hidden = !matches;
if (matches) count++;
});
this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
this.querySelector('[data-count]').textContent = count + ' ' + (count === 1 ? this.dataset.countOne : this.dataset.countLabel);
this.querySelector('[data-clear]').hidden = !this.input.value && this.category === 'all';
this.querySelector('[data-empty]').hidden = count > 0;
if (save) {
const url = new URL(window.location.href);
if (this.input.value.trim()) url.searchParams.set('guide_q', this.input.value.trim()); else url.searchParams.delete('guide_q');
if (this.category !== 'all') url.searchParams.set('application', this.category); else url.searchParams.delete('application');
window.history.replaceState(window.history.state, '', url);
}
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
